module.exports = __webpack_public_path__ + "static/5gde-53bd75d4410d75cd09a735aaa8f223e5.gif";